import { graphql } from "gatsby";
import React from "react";
import BlogCategories from "../../components/BlogCategories";
import Layout from "../../layouts/default";
import BlogCategory from "../../sections/BlogCategory";

export const query = graphql`
  {
    allContentfulBlogCategory {
      nodes {
        blog_post {
          slug
          title
          category {
            headline
          }
          image {
            fixed(width: 640, height: 640) {
              ...GatsbyContentfulFixed_withWebp
            }
          }
        }
        name
        headline
        description {
          description
        }
        color
        buttonColor
      }
    }
  }
`;

export default function BlogIndex({ data, location }) {
  const categories = data.allContentfulBlogCategory.nodes;

  return (
    <Layout pathName={location.pathname}>
      <BlogCategories
        onScroll={(id) => {
          window.scrollTo({
            top: document.getElementById(id).getBoundingClientRect().top,
            left: 0,
            behavior: "smooth",
          });
        }}
      />
      <BlogCategory
        category={categories.find((c) => c.headline === "Stories")}
      />
      <BlogCategory
        category={categories.find((c) => c.headline === "Spirit")}
      />
      <BlogCategory
        category={categories.find((c) => c.headline === "Skin Care")}
      />
      <BlogCategory
        category={categories.find((c) => c.headline === "Self-Care")}
      />
    </Layout>
  );
}
